import { EntityTypeOld, ErrorStateOld } from "../interfaces/products";

export type Downtime = EntityTypeOld<DomainStatus, OperationType>;

export interface DomainStatus {
  readonly services: ServiceStatus[];
}

export interface ServiceStatus {
  readonly name: string;
  readonly isDown: boolean;
  readonly isDownTitle: string;
  readonly isDownMessage: string;
  readonly isUnstable: boolean;
  readonly isUnstableTitle: string;
  readonly isUnstableMessage: string;
  readonly priority?: number;
}

export enum OperationType {
  FETCH_DOWNTIME = "FETCH_DOWNTIME",
}

export type DowntimeError = ErrorStateOld<OperationType>;
